module.exports = __webpack_public_path__ + "media/img/vca/nomf3-817e0b3e2dd21d411c3ef9cb94c56b56.png";